import { Component } from '@angular/core';
import { Platform, Events, App, AlertController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { FormGroup, FormControl } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { GlobalData } from '../providers/GlobalData';
import { NativeService } from '../providers/NativeService';
import { HttpService } from '../providers/HttpService';
import { IS_APP } from '../providers/Constants';
import { Keyboard } from '@ionic-native/keyboard';
import moment from 'moment';
import 'intl';
import 'intl/locale-data/jsonp/zh'; 



@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage: any = 'TabsPage';
  constructor(
    public storage: Storage,
    public globalData: GlobalData,
    public nativeService: NativeService,
    public events: Events,
    public app: App,
    public httpService: HttpService,
    public platform: Platform,
    public keyboard: Keyboard,
    statusBar: StatusBar,
    public alertCtrl: AlertController,
    splashScreen: SplashScreen) {
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.keyboard.disableScroll(true);
      this.keyboard.hideKeyboardAccessoryBar(true);

      statusBar.styleDefault();
      splashScreen.hide();
      moment.locale('zh-cn');
      //检测app版本
      if (IS_APP) {
        this.nativeService.detectionUpgrade();
      };
      let that = this;
      this.storage.get('token').then(function (data) {
        if (data) {
          that.globalData.token = data;
        }
        that.httpService.post('GetCurrentUserInfo', null, false, false).subscribe(res => {
          var result = res.json().result;
          that.storage.set('user', result);//把用户存起来
          if (result.userName) {
            //如果有值 说明已经属于登录状态了
            that.globalData.isLogin = true;
          } else {
            that.globalData.isLogin = false;
          }
        });
      }); 
    }); 
  } 
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts